/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsReplay: {
  name: 'replay';
  data: string;
} = {
  name: 'replay',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 3a.5.5 0 0 0-1 0v10a.5.5 0 0 0 1 0V3Zm3.82-.384A.5.5 0 0 0 6.5 3v10a.5.5 0 0 0 .82.384l6-5a.5.5 0 0 0 0-.768l-6-5Zm.18 9.316V4.068L12.219 8 7.5 11.932Z" fill="currentColor"/></svg>`,
};
